import { render } from "./ObrasTpServicoEditPage.vue?vue&type=template&id=f27a12ce"
import script from "./ObrasTpServicoEditPage.vue?vue&type=script&lang=js"
export * from "./ObrasTpServicoEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__